import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body p-9" }
const _hoisted_2 = { class: "row mb-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "TAX ID", -1)
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Social security", -1)
const _hoisted_7 = { class: "col-lg-8 fv-row" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Company name", -1)
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Accepting invoices at", -1)
const _hoisted_13 = { class: "col-lg-8" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\"> Address invoice to </label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">W.E ApS <br> Noerrebrogade 42, 3th <br> 2200 kbh N <br>Denmark</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">VAT</label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">DK25250060</span></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WantedInvoiceEmail = _resolveComponent("WantedInvoiceEmail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(["fw-bolder fs-6 text-dark", _ctx.getSingleUser.payment_settings.tax_id ? '' : 'text-muted'])
        }, _toDisplayString(_ctx.getSingleUser.payment_settings.tax_id
              ? _ctx.getSingleUser.payment_settings.tax_id
              : "No data"), 3)
      ])
    ]),
    (_ctx.$can('can_view_social_security_number', 'all') || _ctx.isAtOwnProfile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(["fw-bold fs-6", 
            _ctx.getSingleUser.payment_settings.social_security ? '' : 'text-muted'
          ])
            }, _toDisplayString(_ctx.getSingleUser.payment_settings.social_security
              ? _ctx.getSingleUser.payment_settings.social_security
              : "No data"), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: _normalizeClass(["fw-bold fs-6", 
            _ctx.getSingleUser.payment_settings.company_name ? '' : 'text-muted'
          ])
        }, _toDisplayString(_ctx.getSingleUser.payment_settings.company_name
              ? _ctx.getSingleUser.payment_settings.company_name
              : "No data"), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_WantedInvoiceEmail, { class: "fw-bold fs-6 text-dark" })
      ])
    ]),
    _hoisted_14
  ]))
}